<!-- eslint-disable vue/require-v-for-key -->
<template>
    <div>
        <b-row>
            <b-col sm="12">
                <app-tabela
                    idTabela="tblContratosSaldoAnual"
                    :itens="relatorio"
                    :itensPorPagina="itensPorPagina"
                    :campos="campos"    
                >
                    <template slot="contrato" slot-scope="data">
                        <span>
                            Contrato: <strong>({{ data.codigoContrato }}) {{ data.objetoContrato }} - {{ data.fornecedor }}</strong>
                        </span>
                        <br>
                        <span>
                            Prazo: 
                            <strong>
                                {{
                                    $moment(data.dataInicial).format(
                                        'DD/MM/YYYY'
                                    )
                                }}
                                <span> - </span>
                                {{
                                    $moment(data.dataFinal).format(
                                        'DD/MM/YYYY'
                                    )
                                }}
                            </strong>
                        </span>
                        <br>
                        <span>
                            Valor Global: <strong> {{ data.valorGlobal | currency }}</strong>
                        </span>
                        <br>
                        <span>
                            Saldo Real: <strong>{{ data.saldoRealAtual | currency}}</strong>
                        </span>
                        <br>
                    </template>
                    
                    <template v-for="mes in 12" :slot="campos[mes].key" slot-scope="data">
                        <div v-if="data.relatorioContratoAnual[mes-1].valorPrevisto != 0">
                            <span >P: <strong> {{ data.relatorioContratoAnual[mes-1].valorPrevisto | currency }}</strong></span>
                            <br>
                            <span
                            >
                                R: <span :style="{'color': corRealizadoMaiorPrevisto(data.relatorioContratoAnual[mes-1])}">
                                    <strong > {{ data.relatorioContratoAnual[mes-1].valorConsumido | currency }}</strong>
                                </span> 
                            </span>
                        </div>
                        <div v-if="data.relatorioContratoAnual[mes-1].valorPrevisto == 0">
                            <span><strong>-</strong></span>
                        </div>    
                    </template>
                </app-tabela>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    props: {
        relatorio: {
            type: Array
        }
    },

    methods: {
        corRealizadoMaiorPrevisto(mes) {
            let dataMesNormalizada = this.$moment(mes.competencia).format('DD/MM/YYYY')
            let dataAtualNormalizada = this.$moment(new Date()).format('01/MM/YYYY')
            if (dataMesNormalizada > dataAtualNormalizada)
            {
                return null
            }
            return mes.valorConsumido > mes.valorPrevisto ? 
                'blue' : mes.valorConsumido == mes.valorPrevisto ?
                    'green' : 'red'
        }
    },  

    data() {
        return {
            campos: [
                {
                    key: 'contrato',
                    label: 'Contrato',
                },
                {
                    key: 'jan',
                    label: 'JAN',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'fev',
                    label: 'FEV',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'mar',
                    label: 'MAR',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'abr',
                    label: 'ABR',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'mai',
                    label: 'MAI',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'jun',
                    label: 'JUN',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'jul',
                    label: 'JUL',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'ago',
                    label: 'AGO',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'set',
                    label: 'SET',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'out',
                    label: 'OUT',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'nov',
                    label: 'NOV',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'dez',
                    label: 'DEZ',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 0
        }
    },
}

</script>